import { useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import { useGetProjectTags } from '@/service-library/hooks/project-tags'
import { useDocumentFiltersContext } from '@/components/document-filters/DocumentFiltersProvider'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'
import TagChip from '@/components/tags/TagChip'
import TagSelectMenu from '@/components/tags/TagSelectMenu'

export default function TagsFilter() {
  const { project } = useProjectContext()
  const overlay = useOverlay()
  const [searchText, setSearchText] = useState('')
  const { projectTags } = useGetProjectTags({
    filters: {
      limit: '1000',
      project_id: project.id,
    },
  })

  const filterContext = useDocumentFiltersContext()
  const { documentFilters, handleOnDocumentFilterChange } = filterContext

  const selectedTags = projectTags.filter(
    (tag) => documentFilters?.tagIds?.includes(tag.id) || false,
  )

  const onChangeHandler = (tagId: string) => {
    handleOnDocumentFilterChange((prev) => {
      if (!prev)
        return {
          flagCodes: [],
          orgIds: [],
          teamIds: [],
          noFlags: false,
          tagIds: [tagId],
        }

      const newFilters = { ...prev }
      if (newFilters.tagIds.includes(tagId)) {
        newFilters.tagIds = newFilters.tagIds.filter((id) => id !== tagId)
      } else {
        newFilters.tagIds = [...newFilters.tagIds, tagId]
      }
      return newFilters
    })
  }

  return (
    <Stack spacing={1}>
      <Typography variant="body1">Tags</Typography>
      <Box>
        <Button variant="text" onClick={overlay.open} sx={{ ml: -0.5 }}>
          Filter by Tag
        </Button>
      </Box>
      {selectedTags.map((tag) => (
        <Box key={tag.id} sx={{ width: 'min-content' }}>
          <TagChip
            tag={tag}
            onDelete={(tag) => {
              onChangeHandler(tag.id as string)
            }}
          />
        </Box>
      ))}

      <TagSelectMenu
        overlay={overlay}
        selectedProjectTags={selectedTags}
        onTagClick={(projectTag) => onChangeHandler(projectTag.id)}
        searchText={searchText}
        setSearchText={setSearchText}
      />
    </Stack>
  )
}
